module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('module-spinner', {
    attrs: {
      "active": _vm.loading,
      "floating": true
    }
  }), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [(!_vm.loading) ? _c('div', [_c('h3', {
    staticClass: "h3 mt0"
  }, [_vm._v("Dentist Reviewer Request")]), _vm._v(" "), _c('p', {
    staticClass: "p"
  }, [_vm._v("The following dentist requested to become a reviewer:")]), _vm._v(" "), _c('h4', {
    staticClass: "h4 mt2"
  }, [_vm._v("Dentist Details")]), _vm._v(" "), _c('p', {
    staticClass: "mt"
  }, [_vm._v("View: "), _c('a', {
    staticClass: "c-secondary fw-bold",
    attrs: {
      "href": _vm.request.identity_card,
      "target": "_blank"
    }
  }, [_vm._v("Uploaded ID Card")])]), _vm._v(" "), _c('p', {
    staticClass: "mt"
  }, [_vm._v("View: "), _c('a', {
    staticClass: "c-secondary fw-bold",
    attrs: {
      "href": _vm.request.dental_license,
      "target": "_blank"
    }
  }, [_vm._v("Uploaded Dental License")])]), _vm._v(" "), _c('p', {
    staticClass: "mt mb2"
  }, [_vm._v("View: "), _c('a', {
    staticClass: "c-secondary fw-bold",
    attrs: {
      "href": _vm.request.specialty_certificate,
      "target": "_blank"
    }
  }, [_vm._v("Uploaded Speciality Certificate")])]), _vm._v(" "), _c('module-detail-list', {
    attrs: {
      "items": {
        'Title:': "Dr",
        'First Name:': _vm.request.doctor.first_name,
        'Last Name:': _vm.request.doctor.last_name,
        'Email Address:': _vm.request.doctor.email,
        'License Number:': _vm.request.doctor.profile.license_number,
        'Phone Number:': _vm.request.doctor.profile.phone_number,
        'Speciality:': _vm.reviewNomenclatureBySlugAndId("specialties", _vm.request.doctor.profile.specialty),
      }
    }
  }), _vm._v(" "), _vm._l((_vm.request.doctor.clinics), function(location, index) {
    return _c('div', {
      key: index
    }, [_c('h4', {
      staticClass: "h4 mt2"
    }, [_vm._v("Location " + _vm._s(index + 1))]), _vm._v(" "), _c('module-detail-list', {
      attrs: {
        "items": {
          'Address Line One': location.address_1,
          'Address Line Two': location.address_2,
          'City': location.city,
          'State': location.state,
          'ZIP': location.zipcode,
        }
      }
    })], 1)
  }), _vm._v(" "), (_vm.request.status === 1 || _vm.request.status === 3) ? _c('div', [_c('module-button', {
    staticClass: "mr2",
    attrs: {
      "size": "m",
      "button": "primary",
      "label": "approve",
      "loading": _vm.buttonLoading === "approve",
      "disabled": _vm.buttonLoading === "deny"
    },
    nativeOn: {
      "click": function($event) {
        _vm.approve(true)
      }
    }
  }), _vm._v(" "), (_vm.request.status === 1) ? _c('module-button', {
    attrs: {
      "size": "m",
      "button": "primary",
      "label": "refuse",
      "loading": _vm.buttonLoading === "deny",
      "disabled": _vm.buttonLoading === "approve"
    },
    nativeOn: {
      "click": function($event) {
        _vm.approve(false)
      }
    }
  }) : _vm._e()], 1) : _c('p', {
    staticClass: "fw-bold mt2"
  }, [_vm._v("This request has already been completed")])], 2) : _vm._e()])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5e99aa29"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./client/views/dashboard/ReviewerRequest.vue
// module id = 354
// module chunks = 0